import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PagingOptions, TextAreaOptions } from 'bnsights-control-library';
import { LogsService } from '../../shared/Services/LogsService';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bnsights-utilities-library';


@Component({
  selector: 'lib-log',
  templateUrl: './log.component.html'
})
export class LogComponent implements OnInit {
  ApiUrl = "/api/admin/Logs/"
  LogsPagingResult: any[] = [];
  LogsPaging: PagingOptions;
  IsFilterLoaded: boolean = false;
  ProductionMode: boolean = false;
  @ViewChild('LogsPagingViewElement', { static: false }) input: ElementRef;

  //View logs modal
  ViewFileForm = new FormGroup({});
  FileName: string;
  ViewFileData: TextAreaOptions;
  @ViewChild('CloseViewFileModal', { static: false }) CloseViewFileModal: ElementRef;


  language: string = ""
  // Decorator wires up blockUI instance
  ShowPageContent:boolean=false

  constructor(private authService:AuthService,private pageInfoService:PageInfoService, public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService, private LogsService: LogsService, private modalService: NgbModal) {

  }

  async ngOnInit(): Promise<void> {
    this.ShowPageContent=true;
    PageInfoService.PageTitle=this.utilityService.getResourceValue("Logs")
    PageInfoService.PageBreadcrumbs=[
       {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false}

    ];
    this.pageInfoService.calculateTitle();
    this.pageInfoService.calculateBreadcrumbs();
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language = await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode()
    this.LoadList();
  }
 

  LoadList() {
      this.LogsPaging = new PagingOptions();
      this.LogsPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetLogsByFilter';
      this.LogsPaging.ValidationToken = this.authService.authorizationHeaderValue()
      this.IsFilterLoaded = true;
      
  }

  ReinitializeLogsPaging() {
    let element = this.input as any;
    element.ReinitializePaging();
  }

  UpdateLogsPaging() {
    let element = this.input as any;
    element.UpdatePaging();
  }

  setPublicHolidayListResult(result) {
    this.LogsPagingResult = result;
    this.ShowPageContent=true;
    this.utilityService.stopBlockUI();
  }

showFileDataModal(id:string,name:string,ViewFileDataModal){
  this.ViewFileForm = new FormGroup({});
  this.LogsService.ViewFile(id).subscribe((result) => {
    let data = result as any
    this.FileName = name;
    console.log(data);

    this.ViewFileData = new TextAreaOptions();
    this.ViewFileData.Name = "GenerateCodeTextArea";
    this.ViewFileData.Value = data.text;
    this.ViewFileData.IsDisabled = true;
    this.ViewFileData.HideLabel = true;
    this.ViewFileData.Rows = 20;
    this.ViewFileData.Cols = 20;
    this.ViewFileData.MaxLength = 1000000;
    this.modalService.open(ViewFileDataModal);
  }, (error) => {
    
  })
}


}
